import { twCn } from "@/utils";
import React from "react";

export const ScaleLines = () => {
  const percentages = [0, 25, 50, 75, 100];

  return (
    <>
      {percentages.map((percentage) => {
        return (
          <div
            key={percentage}
            className="z-10"
            style={{
              position: "absolute",
              height: "100%",
              left: `${percentage}%`,
            }}
          >
            <div
              className={twCn(
                "w-0.5 border-l -translate-x-1/2 border-dark/50 dark:border-blue-200/50 border-dotted",
                {
                  "w-[5px] bg-dark/50 dark:bg-blue-200/50 rounded-sm border-none":
                    !percentage,
                },
              )}
              style={{
                position: "absolute",
                height: "100%",
              }}
            />
            <div
              className="text-dark dark:text-white font-mono"
              style={{
                position: "absolute",
                bottom: "-1.5rem",
                transform: "translateX(-50%)",
              }}
            >
              {percentage}%
            </div>
          </div>
        );
      })}
    </>
  );
};
